import { createContext } from "react";

export const ProjectModalContext = createContext({
  openAddProject: () => {},
  openAddClient: () => {},
  openAddNewTask: () => {},
  closeProjectModals: () => {},
  isAddProjectOpen: false,
  isAddClientOpen: false,
  isAddTaskOpen: false,
  registerProjectSaveCallback: () => {},
  registerClientSaveCallback: () => {},
  registerTaskSaveCallback: () => {},
  selectedProject: null,
  setSelectedProject: () => {},
  updateSelectedProject: () => {},
  clearSelectedProject: () => {},
  // NEW
  refreshSelectedProject: () => {},
  registerRefreshCallback: () => {},
});